/**
 * 添加投放关键词表单弹窗
 * 限制: <120行
 */
import React from 'react';
import { Modal, Form, Input, Select, InputNumber, Row, Col } from 'antd';
import type { FormInstance } from 'antd';
import { KEYWORD_TYPE_OPTIONS, MATCH_TYPE_OPTIONS } from './types';


interface AddKeywordModalProps {
    visible: boolean;
    form: FormInstance;
    onOk: () => void;
    onCancel: () => void;
}

export const AddTargetingKeywordModal: React.FC<AddKeywordModalProps> = ({
    visible,
    form,
    onOk,
    onCancel,
}) => {
    return (
        <Modal
            title="添加投放关键词"
            open={visible}
            onOk={onOk}
            onCancel={onCancel}
            width={600}
        >
            <Form form={form} layout="vertical">
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="keyword"
                            label="关键词"
                            rules={[{ required: true, message: '请输入关键词' }]}
                        >
                            <Input.TextArea
                                placeholder="输入关键词，多个关键词请换行分隔"
                                rows={3}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="keyword_type"
                            label="词性"
                            initialValue="core_exact"
                        >
                            <Select
                                options={Object.entries(KEYWORD_TYPE_OPTIONS).map(([value, label]) => ({
                                    value,
                                    label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="match_type"
                            label="匹配类型"
                            initialValue="exact"
                        >
                            <Select
                                options={Object.entries(MATCH_TYPE_OPTIONS).map(([value, label]) => ({
                                    value,
                                    label,
                                }))}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="conversion_rate" label="转化率">
                            <InputNumber
                                min={0}
                                max={1}
                                step={0.01}
                                placeholder="0.00"
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="search_volume" label="搜索量">
                            <InputNumber
                                min={0}
                                placeholder="0"
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="priority" label="优先级" initialValue={3}>
                            <InputNumber min={1} max={5} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="estimated_cpc" label="预估CPC">
                            <InputNumber
                                min={0}
                                step={0.01}
                                placeholder="0.00"
                                prefix="$"
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="notes" label="备注">
                            <Input.TextArea rows={2} placeholder="可选备注" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default AddTargetingKeywordModal;
